module.exports = __webpack_public_path__ + "img/logo.fea64a64.svg";